<template>
    <div class="py-4 py-md-5 px-4 px-md-5 bg-white">
        <preface />
    </div>
</template>

<script>
import Preface from  '@shared_components/client/components/Preface'

export default {
    name: 'ParticipateLanding',
    components: {
        Preface
    },
    data() {
        return {}
    },
    computed: {},
    methods: {}
}
</script>

<style>
/* .sup-landing-nav {
    background-color: var(--gray-200);
    border-bottom: 0;
}
.sup-landing-nav > .nav-item {
    border: 0;
    height: 44px;
    margin-top: 4px;
}
.sup-landing-nav > .nav-item:hover > a, 
.sup-landing-nav > .nav-item > a,
.sup-landing-nav > .nav-item.show > a {
    background-color: rgba(0,0,0,0);
    border: 0;
    font-weight: 500;
}
.sup-landing-nav > .nav-item > a {
    color: var(--gray-600);
    position: relative;
}
.sup-landing-nav > .nav-item:hover > a {
    color: var(--gray-900);
}
.sup-landing-nav > .nav-item.show > a {
    color: var(--gray-900);
}
.sup-landing-nav > .nav-item.show > a::after,
.sup-landing-nav > .nav-item:hover > a::after {
    content: "";
    position: absolute;
    top: 33px;
    left: 50%;
    margin-left: -10px;
    width: 0px;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-bottom: 10px solid white;
} */
</style>
